export const generateInitials = (
  firstName: string | null | undefined,
  lastName: string | null | undefined,
) => {
  if (!firstName && !lastName) return "A";

  return `${firstName?.[0]}${lastName?.[0]}`.toUpperCase();
};
